import React, { useEffect, useState } from "react";
import { Button } from "../../../../_helpers/components/Button";
import { InputForm } from "../../../../_helpers/components/Forms/InputLabel";
import { getCompany, putCompany } from "../../../../_api/Company";
import { Loader } from "../../../../_helpers/components/Forms/Loader";
import { getEstablishments } from "../../../../_api/Establishment";
import { Table } from "../../../../_helpers/Table";
import { useNavigate, useOutletContext } from "react-router-dom";

import toast from "react-hot-toast";

export const InformationTab = () => {
    const navigate = useNavigate();
    const [user, setUser, currentApp, currentMenu, currentTab, setCurrentTab, setCurrentMenu] = useOutletContext();
    const features_right = user.policy.rights[currentApp][currentMenu.id]["sub_menu"]["COMPANY"]["features"];

    const [invoiceEmail, setInvoiceEmail] = useState("");
    const [invoiceMobile, setInvoiceMobile] = useState("");

    const [businessEmail, setBusinessEmail] = useState("");
    const [businessMobile, setBusinessMobile] = useState("");

    const [siret, setSIRET] = useState("");
    const [name, setName] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const [establishments, setEstablishments] = useState([]);

    const loadCompany = async () => {
        setIsLoading(true);
        await getCompany().then((resp) => {
            setName(resp.data.name ?? "");
            setInvoiceEmail(resp.data.invoicing_mail ?? "");
            setInvoiceMobile(resp.data.invoicing_number ?? "");
            setBusinessEmail(resp.data.business_mail ?? "");
            setBusinessMobile(resp.data.business_number ?? "");
            setSIRET(resp.data.siret ?? "");
        });
        setIsLoading(false);
    };

    const updateCompany = async () => {
        const payload = {
            invoicing_mail: invoiceEmail,
            invoicing_number: invoiceMobile,
            business_mail: businessEmail,
            business_number: businessMobile,
            siret: siret,
        };
        try {
            const resp = await putCompany(payload);
            setInvoiceEmail(resp.data.invoicing_mail);
            setInvoiceMobile(resp.data.invoicing_number);
            setBusinessEmail(resp.data.business_mail);
            setBusinessMobile(resp.data.business_number);
            setSIRET(resp.data.siret);
            toast.success("Informations mises à jour avec succès");
        } catch (error) {
            toast.error("Erreur lors de la mise à jour");
        }
    };

    useEffect(() => {
        loadCompany();
        loadEstablishments();
    }, []);

    const headers = ["Intitulé", "Adresse", "Date de création"];

    const loadEstablishments = async () => {
        setIsLoading(true);
        await getEstablishments().then((resp) => {
            if (!resp.data) {
                setEstablishments([]);
                return;
            }
            const res = resp.data.map((res) => {
                return {
                    row: [
                        res.name,
                        res.address,
                        new Date(
                            res.establishment_creation
                        ).toLocaleDateString(),
                    ],
                    data: res,
                };
            });
            setEstablishments(res);
        });
        setIsLoading(false);
    };
    const rowClick = (value) => {
        navigate(`/company/establishments/${value.id}`);
    };

    return (
        <div className="min-h-full bg-gray-50">
            {/* Header */}
            <div className="bg-white border-b border-gray-200 shadow-sm">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
                    <div>
                        <h1 className="text-3xl font-bold text-gray-900">
                            Informations de l'entreprise
                        </h1>
                        <p className="mt-2 text-sm text-gray-600">
                            Gérez les informations de contact et les établissements
                        </p>
                    </div>
                </div>
            </div>

            {isLoading ? (
                <Loader text="Chargement des informations..." />
            ) : (
                <>
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 space-y-6">
                        <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
                            {/* Colonne gauche - Informations de contact */}
                            <div className="space-y-6">
                                {/* Carte Contact de facturation */}
                                <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 hover:shadow-md transition-shadow duration-200">
                                    <div className="flex items-center mb-4">
                                        <div className="flex items-center justify-center w-10 h-10 bg-blue-100 rounded-lg mr-3">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="h-6 w-6 text-blue-600"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth={2}
                                                    d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                                                />
                                            </svg>
                                        </div>
                                        <h2 className="text-xl font-semibold text-gray-900">
                                            Contact de facturation
                                        </h2>
                                    </div>
                                    <div className="space-y-4">
                                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                                            <div className="md:col-span-2">
                                                <InputForm
                                                    name="Email"
                                                    value={invoiceEmail}
                                                    placeholder="email@exemple.fr"
                                                    type="email"
                                                    set={setInvoiceEmail}
                                                />
                                            </div>
                                            <div>
                                                <InputForm
                                                    name="Téléphone"
                                                    value={invoiceMobile}
                                                    placeholder="00 00 00 00 00"
                                                    set={setInvoiceMobile}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Carte Contact métier */}
                                <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 hover:shadow-md transition-shadow duration-200">
                                    <div className="flex items-center mb-4">
                                        <div className="flex items-center justify-center w-10 h-10 bg-green-100 rounded-lg mr-3">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="h-6 w-6 text-green-600"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth={2}
                                                    d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                                                />
                                            </svg>
                                        </div>
                                        <h2 className="text-xl font-semibold text-gray-900">
                                            Contact métier
                                        </h2>
                                    </div>
                                    <div className="space-y-4">
                                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                                            <div className="md:col-span-2">
                                                <InputForm
                                                    name="Email"
                                                    value={businessEmail}
                                                    placeholder="email@exemple.fr"
                                                    type="email"
                                                    set={setBusinessEmail}
                                                />
                                            </div>
                                            <div>
                                                <InputForm
                                                    name="Téléphone"
                                                    value={businessMobile}
                                                    placeholder="00 00 00 00 00"
                                                    set={setBusinessMobile}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Carte Informations légales */}
                                <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 hover:shadow-md transition-shadow duration-200">
                                    <div className="flex items-center mb-4">
                                        <div className="flex items-center justify-center w-10 h-10 bg-purple-100 rounded-lg mr-3">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="h-6 w-6 text-purple-600"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth={2}
                                                    d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                                                />
                                            </svg>
                                        </div>
                                        <h2 className="text-xl font-semibold text-gray-900">
                                            Informations légales
                                        </h2>
                                    </div>
                                    <div className="space-y-4">
                                        <div>
                                            <InputForm
                                                name={`SIRET - ${name}`}
                                                value={siret}
                                                placeholder="123 456 789 00012"
                                                set={setSIRET}
                                            />
                                        </div>
                                    </div>
                                </div>

                                {/* Bouton de sauvegarde */}
                                <div className="flex justify-end pt-2">
                                    <Button
                                        action={(e) => updateCompany(e)}
                                        name={
                                            <span className="flex items-center">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    className="h-5 w-5 mr-2"
                                                    fill="none"
                                                    viewBox="0 0 24 24"
                                                    stroke="currentColor"
                                                >
                                                    <path
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        strokeWidth={2}
                                                        d="M5 13l4 4L19 7"
                                                    />
                                                </svg>
                                                Enregistrer les modifications
                                            </span>
                                        }
                                        type={"empty"}
                                        isVisible={features_right["modify_contact_info"]}
                                    />
                                </div>
                            </div>

                            {/* Colonne droite - Établissements */}
                            <div className="xl:sticky xl:top-6 xl:self-start">
                                <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
                                    <div className="p-6">
                                        <div className="flex items-center justify-between mb-4">
                                            <div className="flex items-center">
                                                <div className="flex items-center justify-center w-10 h-10 bg-orange-100 rounded-lg mr-3">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        className="h-6 w-6 text-orange-600"
                                                        fill="none"
                                                        viewBox="0 0 24 24"
                                                        stroke="currentColor"
                                                    >
                                                        <path
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                            strokeWidth={2}
                                                            d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                                                        />
                                                    </svg>
                                                </div>
                                                <h2 className="text-xl font-semibold text-gray-900">
                                                    Établissements
                                                </h2>
                                            </div>
                                            {features_right["add_establishment"] && (
                                                <Button
                                                    type="empty"
                                                    action={() => navigate("/company/establishment/create")}
                                                    name="Ajouter"
                                                />
                                            )}
                                        </div>
                                        <div className="mt-4">
                                            {establishments.length === 0 ? (
                                                <div className="text-center py-8 text-gray-500">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        className="h-12 w-12 mx-auto mb-3 text-gray-400"
                                                        fill="none"
                                                        viewBox="0 0 24 24"
                                                        stroke="currentColor"
                                                    >
                                                        <path
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                            strokeWidth={2}
                                                            d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                                                        />
                                                    </svg>
                                                    <p className="text-sm">Aucun établissement</p>
                                                    <p className="text-xs text-gray-400 mt-1">
                                                        Cliquez sur "Ajouter" pour en créer un
                                                    </p>
                                                </div>
                                            ) : (
                                                <Table
                                                    headers={headers}
                                                    rows={establishments}
                                                    onClick={rowClick}
                                                />
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    )
};
